import DynamicFieldInfo from "./DynamicFieldInfo";

export default DynamicFieldInfo;



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldInfo/index.js